import { useState } from 'react'

const useVideoSharingBar = () => {
  const [sendEmailModalVisible, setSendEmailModalVisible] = useState(false)
  const [privacyModalVisible, setPrivacyModalVisible] = useState(false)

  const togglePrivacyModalVisibility = () => {
    setPrivacyModalVisible((prevState) => !prevState)
  }

  const showSendByEmailModal = () => {
    setSendEmailModalVisible(true)
  }

  const hideSendByEmailModal = () => {
    setSendEmailModalVisible(false)
  }
  return {
    privacyModalVisible,
    sendEmailModalVisible,
    togglePrivacyModalVisibility,
    showSendByEmailModal,
    hideSendByEmailModal,
  }
}
export default useVideoSharingBar
